import { createAsyncType } from '@/store/utils/mutation-types'
import axios from 'axios'
import { createResource as createMonthFilterResource } from '@/store/utils/month-filter-resource'

const monthFilterResource = createMonthFilterResource()

const types = {
  GET_MY_TEAM_DASHBOARD: createAsyncType('GET_MY_TEAM_DASHBOARD')
}

export default {
  namespaced: true,
  state () {
    return {
      items: null,
      status: void 0,
      ...monthFilterResource.state
    }
  },
  actions: {
    async getItems ({ commit }, { months }) {
      commit(types.GET_MY_TEAM_DASHBOARD.REQUEST)
      try {
        commit(types.GET_MY_TEAM_DASHBOARD.SUCCESS, await axios.get('/api/myTeam/dashboard', { params: { months } }))
      } catch (err) {
        commit(types.GET_MY_TEAM_DASHBOARD.FAILURE)
      } finally {
      }
    },
    ...monthFilterResource.actions
  },
  mutations: {
    [types.GET_MY_TEAM_DASHBOARD.REQUEST]: state => {
      state.status = 'fetching'
    },
    [types.GET_MY_TEAM_DASHBOARD.SUCCESS]: (state, result) => {
      state.status = 'success'
      state.items = result.data
    },
    [types.GET_MY_TEAM_DASHBOARD.FAILURE]: state => {
      state.status = 'failure'
    },
    ...monthFilterResource.mutations
  }
}
